import React from "react";
import ReactDOM from "react-dom/client";
import { LicenseManager } from "ag-grid-enterprise";
import "mdbreact/dist/css/mdb.css";
import "bootstrap-css-only/css/bootstrap.min.css";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "./tailwind.css";
import "./dayjs-setup";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import store from "./redux/store";
import "react-toastify/dist/ReactToastify.css"; // Don't forget to import the CSS if you want to use the default styles.
import SystemUpdateNotice from "./components/systemUpdateNotice/SystemUpdateNotice";
import { isMaintenanceMode } from "./utils/maintenanceMode";

const licenseKey = process.env.REACT_APP_AG_GRID_LICENSE_KEY;
if (licenseKey) {
	LicenseManager.setLicenseKey(licenseKey);
}

const root = ReactDOM.createRoot(
	document.getElementById("root") as HTMLElement
);
// Maintenance mode swaps out the whole tree, not a route inside it. Without the router there are
// no routes left to reach, and without <App /> nothing mounts that could call the API or open a
// SignalR hub — so every URL shows the notice and the front end stays completely quiet while the
// system is being updated. Toggle it with MAINTENANCE_MODE (config.json / container env).
root.render(
	<React.StrictMode>
		{isMaintenanceMode() ? (
			<SystemUpdateNotice />
		) : (
			<BrowserRouter>
				<Provider store={store}>
					<App />
				</Provider>
			</BrowserRouter>
		)}
	</React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
